import { useEffect, useState, useContext } from "react"
import { GlobalContext } from '../_app'

import { Header, HeaderShim } from "../../fuselage/global/header/header"
import { Footer } from '../../fuselage/theme/2024/layout/footer/footer'

import { StickySidebar } from "../../fuselage/layout/sticky-sidebar/sticky-sidebar"
import { Slide, Pop, Fade } from "../../fuselage/animation/animation"
import { VideoPlayer } from "../../fuselage/components/video-player/video-player"
import { decodeHtmlEntities } from "../../lib/decode-html-entities"

export default function Data () {

	const globals = useContext(GlobalContext)
	
	const [videos, setVideos] = useState(null)
	const [videosLoading, setVideosLoading] = useState(true)

	const url = "https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=UCtiJqpefd0Wv0h6YVMZYbGA&maxResults=14&order=date&type=video&key=AIzaSyCLOZc00U47ESr82hC1ZZ-icWqn1sfRaQA"

    useEffect( () => {
		fetch(url, {
			method: "GET"
		})
			.then((res) => res.json())
			.then((result) => {
				setVideos(result)
				setVideosLoading(false)
			})
			.catch((error) => {
				console.error('Error fetching data:', error)
				setVideosLoading(false)
			})
    }, [])



    return (
        <>
			<Header mainMenu={globals.nodes} />
			<HeaderShim mobileOnly/>

			<section className="block bg-medium pt-0">
				<StickySidebar size='small'>
					<aside className="formatted">
                        <HeaderShim desktopOnly/>
                        <p><a className="uLink fs-6 fw-600 c-primary" href={`/content-library/latest-podcasts`}>Podcasts</a></p>
                        <p><a className="uLink fs-6 fw-600 c-primary here" href={`/content-library/latest-videos`}>Videos</a></p>
                        <p><a className="uLink fs-6 fw-600 c-primary" href={`/content-library/press-room`}>Press Room</a></p>
					</aside>
					
					<main>
						<HeaderShim desktopOnly />
						<div>
							<p className="fs-1 fw-600 c-primary">Content Library</p>
							<p className="fs-2 fw-600 caps mt-md mb-sm">Latest Videos</p>
						</div>
						
						<div className="container columns-2 gap-sm">
							{
								videosLoading && <p>Loading...</p>
							}
							{/* <pre>{JSON.stringify(data, null, 2)}</pre> */}
							{
								videos &&
								videos.items.map((video, index) => {
									return (
										<Pop key={index}>
											<div>
												<VideoPlayer videoUrl={`https://www.youtube.com/watch?v=${video.id.videoId}}`} />
												<p className="fw-500 fs-5 c-white lh-2 mt-xs">{ decodeHtmlEntities(video.snippet.title) }</p>
											</div>
										</Pop>
									)
								})
							}
						</div>
					</main>
				</StickySidebar>
			</section>



			<Footer 
				socialConnections={globals.globalSets[2].socialConnections} 
				contactInfo={globals.globalSets[2].contactDetails[0].body}
				hubspotForm={globals.globalSets[2].hubspotForm[0] ? globals.globalSets[2].hubspotForm[0] : null}
			/>
        </>
    )
}


Data.theme = 'aviadev-2024'